<div class="language-container">
    <label class="labelTitle" for="idioma">{{ 'PREVIEW_SPACE.LANGUAGE_SELECT' | translate }}</label>

    <select2 #idioma [data]="languages" class="select2" (update)="emitValueChange(specificData)"listPosition="above" [(ngModel)]="specificData.idioma">
    </select2>
</div>
